import React, { forwardRef } from 'react'
import type { CardProps, StyleObject } from '@vtex/admin-ui'
import {
  Button,
  Card,
  Flex,
  IconCaretDown,
  Text,
  csx,
  cx,
} from '@vtex/admin-ui'
import type { Ref } from 'react'

import type { SalesPeriod } from './SalesPeriod'
import { SalesPeriodText } from './SalesPeriodText'

export type SalesPeriodButtonOptions = {
  label: string
  value: SalesPeriod
  month?: 'short' | 'long'
  disabled?: boolean
}

export type SalesPeriodButtonProps = Omit<
  CardProps,
  keyof SalesPeriodButtonOptions
> &
  SalesPeriodButtonOptions

export const SalesPeriodButton = forwardRef(function SalesPeriodButton(
  {
    children,
    className = '',
    label,
    value,
    month = 'short',
    disabled = false,
    ...props
  }: SalesPeriodButtonProps,
  ref?: Ref<HTMLDivElement>
) {
  const cursor: StyleObject['cursor'] = disabled ? 'default' : 'pointer'

  return (
    <Card
      ref={ref}
      role="button"
      className={cx(
        csx({
          display: 'flex',
          justifyContent: 'space-between',
          cursor: 'pointer',
          paddingY: '$space-3',
          paddingLeft: '$space-3',
        }),
        className
      )}
      {...props}
    >
      <Flex direction="column" className={csx({ textAlign: 'start' })}>
        <Text variant="detail">{label}</Text>

        <SalesPeriodText value={value} month={month} />
      </Flex>

      {children}

      <Button
        aria-hidden
        variant="tertiary"
        icon={<IconCaretDown size="small" />}
        className={csx({
          borderRadius: 'circle',
          cursor,
        })}
        disabled={disabled}
      />
    </Card>
  )
})
